import React from "react";
import { createRoot } from "react-dom/client";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { UserProvider } from "./context/UserContext.jsx";
import CalendarEntryPoint from "./startup/CalendarEntryPoint.jsx";
import { suppressConsoleInProduction } from "./utils/consoleControl.js";
import "./styles/index.css";

suppressConsoleInProduction();

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
    <React.Suspense>
        <UserProvider>
            <CalendarEntryPoint />
        </UserProvider>
    </React.Suspense>
);
